import { Injectable } from '@angular/core';
import { Observable, catchError, of, retry } from 'rxjs';
import { Product } from '../models/product.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private baseUrl = environment.apiBaseUrl +'/api'; // change to your backend URL 

  constructor(private http: HttpClient) { }

  //getProducts(): Observable<Product[]> {
  //  return this.http.get<Product[]>(`${this.baseUrl}/api/product`).pipe(
  //    retry(3), // Retry the request 3 times if it fails
  //    catchError(error => {
  //      console.error('API products failed', error);
  //      return of([]); // Return an empty list on error

  //    })
  //  );
  //}

  getProducts(): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.baseUrl}/product`);
  }

  getProductsByVendor(): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.baseUrl}/product/GetProductByVendor`);
  }

  getProductById(id: number): Observable<Product> {
    return this.http.get<Product>(`${this.baseUrl}/product/${id}`);
  }

  getProductsByCategory(categoryId: number): Observable<Product[]> {
    //return this.http.get<Cart>(`${this.cartApiUrl}/GetCartItems/${userId}`);
    return this.http.get<Product[]>(`${this.baseUrl}/product/GetProductByCategoryId/${categoryId}`);
  }

  addProduct(product: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/product/`, product);
  }

  updateProductById(id: number, product: any): Observable<Product> {
    return this.http.put<Product>(`${this.baseUrl}/product/${id}`, product);
  }

  deleteProductById(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/product/${id}`);
  }

  //loadCategories() {
  //  this.http.get<any[]>('https://localhost:5001/api/categories') // replace with your real API
  //    .subscribe(data => {
  //      this.categories = data;
  //    });
  //}
}
